import {Tooltip, TooltipContent, TooltipTrigger} from "@/components/ui/tooltip.tsx";
import {ExclamationCircleIcon} from "@heroicons/react/16/solid";
import {PropsWithChildren} from "react";

export function DescriptionSetting({ children }: PropsWithChildren) {
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <ExclamationCircleIcon className="size-3 align-middle inline text-gray-300 hover:text-gray-500 transition" />
            </TooltipTrigger>
            <TooltipContent dir="rtl" className="max-w-60 bg-white shadow-lg align-text-bottom">
                <div className="text-xs text-gray-700 [&>p:not(:first-child)]:mt-1">
                    {children}
                </div>
            </TooltipContent>
        </Tooltip>
    )
}